import { render, staticRenderFns } from "./MyTodos.vue?vue&type=template&id=c145c574"
import script from "./MyTodos.vue?vue&type=script&lang=js"
export * from "./MyTodos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports